<template>
  <div class="row myrow content-mb-42">
    <div class="col-xs-12 mycol" style="width: 750px">
      <table class="co-executor">
        <thead>
          <tr>
            <td>ОГРН</td>
            <td>Юридическое лицо</td>
            <td>Стоимость работ, тыс. руб.</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <template v-for="(item, index) in project.LEGAL_ENTITIES.items">
            <SystemIntegratorList
              :item="item"
              :index="index"
              v-bind:key="index"
            ></SystemIntegratorList>
          </template>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a class="link-add-row" @click="findOrg">Юридическое лицо</a>
      </div>
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showOgrnFind }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showOgrnFind = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление юридического лица</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>ОГРН</label>
              <input
                v-model="ogrn"
                class="form-control"
                placeholder="ОГРН юридического лица"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addSubContact"
              type="button"
              class="btn btn-primary"
            >
              Юридическое лицо
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import SystemIntegratorList from "@/components/project/form/lists/SystemIntegratorList";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { mapGetters } from "vuex";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "legal_entities",
  props: ["project"],
  components: {
    SystemIntegratorList
  },
  data() {
    return {
      showConfirm: false,
      showOgrnFind: false,
      showResident: false,
      showCompIn: false,
      resident: 1,
      inname: "",
      incountry: 0,
      ogrn: ""
    };
  },
  methods: {
    hasError(col, field) {
      if (
        typeof this.$parent.$parent.legalEntitiesErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.legalEntitiesErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    errorText(col, field) {
      if (
        typeof this.$parent.$parent.legalEntitiesErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.legalEntitiesErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.legalEntitiesErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (
        typeof this.$parent.$parent.legalEntitiesErrors[col] !== "undefined"
      ) {
        if (
          typeof this.$parent.$parent.legalEntitiesErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.legalEntitiesErrors[col], field);
        }
      }
      return false;
    },
    addSubContact() {
      ProjectsService.getCoAuthorInfoByOgrn(this.ogrn).then(({ data }) => {
        if (!data.IS_FIND) {
          this.$toasted.show(data.ERROR, {
            theme: "red",
            position: "top-right",
            duration: 3000
          });
          return;
        }
        this.showOgrnFind = false;
        if (typeof this.$parent.project.LEGAL_ENTITIES === "undefined") {
          this.$parent.project.LEGAL_ENTITIES.items = [];
        }
        this.$parent.project.LEGAL_ENTITIES.items.push({
          UF_OGRN: data.UF_OGRN,
          UF_COMPANY_ID: data.UF_COMPANY_ID,
          UF_NAME: data.UF_NAME
        });
      }, this);
    },
    findOrg() {
      this.showResident = false;
      this.ogrn = "";
      this.showOgrnFind = true;
    },
    addItem() {
      if (typeof this.project.LEGAL_ENTITIES === "undefined") {
        this.project.LEGAL_ENTITIES = {
          items: []
        };
      }
      this.project.LEGAL_ENTITIES.items.push({});
    },
    deleteItem(index) {
      this.project.LEGAL_ENTITIES.items.splice(index, 1);
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
